<template>
  <div class="m-edition-asset-content-comments-create m-tinymce-comments">
    <AtomAvatarSecondary :userImage="avatarPrimary.image"/>

    <form
      class="m-edition-asset-content-comments-create-form"
      @submit.prevent=""
    >
      <editor
        v-model="comentario.mensaje"
        :init="tinyMceInit"
      >
      </editor>

      <a
        class="display-block margin-top-medium m-edition-asset-content-comments-create-form-action width-fit-content"
        href="#"
        @click.prevent="createContenidoComentario"
      >
        <span v-if="comentariosTipo === 1 && isSendingComment">
          <i class="far fa-spinner fa-spin"></i>
          {{ $t('mEditionAssetContentCommentsCreate.actions.sendingComment') }}
        </span>
        <span v-else-if="comentariosTipo === 1 && !isSendingComment">
          <i class="far fa-comment"></i>
          {{ $t('mEditionAssetContentCommentsCreate.actions.sendComment') }}
        </span>

        <span v-if="comentariosTipo === 3 && isReply && isSendingComment">
          <i class="far fa-spinner fa-spin"></i>
          {{ $t('mEditionAssetContentCommentsCreate.actions.sendingAnswer') }}
        </span>
        <span v-else-if="comentariosTipo === 3 && isReply && !isSendingComment">
          <i class="far fa-reply"></i>
          {{ $t('mEditionAssetContentCommentsCreate.actions.sendAnswer') }}
        </span>

        <span v-if="comentariosTipo === 3 && !isReply && isSendingComment">
          <i class="far fa-spinner fa-spin"></i>
          {{ $route.name === 'assets'
            ? $t('mEditionAssetContentCommentsCreate.actions.sendingQuestion')
            : $t('mEditionAssetContentCommentsCreate.actions.sendingMessage')
          }}
        </span>
        <span v-else-if="comentariosTipo === 3 && !isReply && !isSendingComment">
          <i :class="$route.name === 'assets'
            ? 'far fa-question-circle'
            : 'far fa-location-arrow'"
          >
          </i>
          {{ $route.name === 'assets'
            ? $t('mEditionAssetContentCommentsCreate.actions.sendQuestion')
            : $t('mEditionAssetContentCommentsCreate.actions.sendMessage')
          }}
        </span>
      </a>

      <div
        id="preguntaEnviada"
        class="m-edition-asset-content-comments-create-question-sent"
      >
        <p class="margin-bottom-xsmall margin-top-zero">
          {{ `¡${$t('mEditionAssetContentCommentsCreate.actions.sentAnswer.firstText')} ${avatarPrimary.user}!` }}
        </p>
        <p class="margin-bottom-zero margin-top-xsmall">
          {{ `${$t('mEditionAssetContentCommentsCreate.actions.sentAnswer.secondText')}` }}
        </p>
      </div>

    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetCommentsCreate',

  components: {
    Editor: () => import('@tinymce/tinymce-vue')
  },

  props: {
    comentariosTipo: Number,
    comment: Object,
    contenido: Object,

    isReply: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      avatarPrimary: {
        component: '',
        image: '',
        email: '',
        user: ''
      },

      comentario: {
        asunto: '',
        mensaje: '',
        padre: '',
        tipo_comentario: ''
      },

      isSendingComment: false,

      tinyMceInit: {
        branding: false,
        forced_root_block: '',
        force_br_newlines: false,
        force_p_newlines: false,
        height: 170,
        language_url: `/tinymce/langs/es.js`,
        language: 'es_ES',
        menubar: false,
        placeholder: '',

        plugins: [
          'emoticons'
        ],

        statusbar: false,

        toolbar: 'emoticons',
        toolbar_location: 'bottom',
        content_style: 'body, td, pre { color: rgba(0, 0, 0, 0.75); font-family: \'Open Sans\', sans-serif; font-size: 14px; font-weight: 400; line-height: 1.8;}'
      },

      usuario: {}
    }
  },

  computed: {
    setPadre () {
      return this.comment ? this.comment.id : null
    }
  },

  watch: {
    comentariosTipo () {
      this.comentario.tipo_comentario = this.comentariosTipo === 1 ? 1 : 2
      console.log(this.comentariosTipo)
      this.tinyMceInit.placeholder = ''
      this.tinyMceInit.placeholder = this.comentariosTipo === 1
        ? this.$t('mEditionAssetContentCommentsCreate.placeholder.writeComment')
        : this.isReply
          ? this.$t('mEditionAssetContentCommentsCreate.placeholder.writeAnswer')
          : this.$t('mEditionAssetContentCommentsCreate.placeholder.writeQuestion')
    }
  },

  created () {
    this.usuario = this.$store.getters.getUserData
    this.avatarPrimary.image = this.usuario.vidroop_data.avatar
    this.avatarPrimary.user = this.usuario.vidroop_data &&
      this.usuario.vidroop_data.persona &&
      this.usuario.vidroop_data.persona.razon_social
      ? this.usuario.vidroop_data.persona.razon_social
      : this.usuario.email
    this.comentario.tipo_comentario = this.comentariosTipo === 1 ? 1 : 2
    this.tinyMceInit.placeholder = this.comentariosTipo === 1
      ? this.$t('mEditionAssetContentCommentsCreate.placeholder.writeComment')
      : this.isReply
        ? this.$t('mEditionAssetContentCommentsCreate.placeholder.writeAnswer')
        : this.$t('mEditionAssetContentCommentsCreate.placeholder.writeQuestion')
  },

  methods: {
    createContenidoComentario () {
      if (!this.isSendingComment && this.comentario.mensaje.length) {
        let nodeId = this.$route.name === 'asset' || this.$route.name === 'assetChild2'
          ? this.$store.getters.getSelectedNode.id
          : this.$store.getters.getSelectedMapNode.id
        this.isSendingComment = true
        this.comentario.padre = this.setPadre
        this.$services.create('contenido', 'createContenidoComentario', this.comentario, [this.contenido.id, nodeId, this.comentario.padre])
          .then(response => {
            if (this.comentariosTipo === 3) {
              this.showPreguntaEnviada()
            }
            this.comentario = {
              asunto: '',
              mensaje: '',
              padre: this.comentario.padre,
              tipo_comentario: this.comentariosTipo === 1 ? 1 : 2
            }
            this.$modal.updateData()
            this.$emit('showReplies')
            this.$emit('toggleCreate')
            this.isSendingComment = false
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    showPreguntaEnviada () {
      document.getElementById('preguntaEnviada').style.display = 'inline-block'

      setTimeout(() => {
        document.getElementById('preguntaEnviada').style.display = 'none'
      }, 9000)
    }
  }
}
</script>
